// initial state
const state = {
  all: null,
  error: 0
}

// getters
const getters = {
  globalVars: state => state.all
}

// actions
const actions = {
  getGlobalVars ({ commit }, data) {
    commit('setGlobalVars', data)
  },
  setError ({commit}, data) {
    commit('setError', data.data)
  }
}

// mutations
const mutations = {
  setGlobalVars (state, all) {
    state.all = all
  },
  setError (state, error) {
    state.error = {error: error, time: Date.now()}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
